export default function updateCertificatesPage() {
  // handle navbar class on scroll
  // ** this may be deprecated in the future **
  let navbar = document.querySelector("#header");

  document.addEventListener("scroll", () => {
    if (window.scrollY > 205) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }
  });

  let sjContent = document.querySelector("#skilljar-content");

  // create page header
  let pageHeader = document.createElement("div");
  pageHeader.id = "certificates-header";

  let pageHeaderText = document.createElement("div");
  pageHeaderText.id = "certificates-header-text";

  pageHeaderText.innerHTML = `
        <h1>
            Earn Certificates
        </h1>
        <p>
            Show the world you're a master of productivity.
        </p>
    `;

  pageHeader.append(pageHeaderText);

  // create sub-header content
  let pageSubHeader = document.createElement("DIV");
  pageSubHeader.id = "certificates-subheader";
  let pageSubHeaderText = document.createElement("DIV");
  pageSubHeaderText.id = "certificates-subheader-text";

  pageSubHeaderText.innerHTML = `
        <div>
            <p>
                <span>Become a Productivity Pro | </span>Take a deeper dive into core features and productivity tips to grow your skills and earn ClickUp Certificates.
            </p>
            <p>
                <span>Perfect your  workflow | </span>As a ClickUp Productivity All-Star, you'll have all the skills you need to build the most efficient Workspace and optimize your workflow.
            </p>
            <p>
                <span>Let your networks know | </span>ClickUp Certificates verify your Workspace knowledge. Share your new credentials via LinkedIn and social media.
            </p>
        </div>
        <img src="https://cu-university-static-staging.web.clickup.com/img/cuu-astrocorn.png">
    `;

  pageSubHeader.append(pageSubHeaderText);

  // create badges cards
  let badgeSection = document.createElement("DIV");
  badgeSection.id = "badge-section";

  let badgeCardSection = document.createElement("DIV");
  badgeCardSection.id = "badge-cards";

  let badgeCards = [
    {
      src: "https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-novice-badge.png",
      title: "Novice Certificate",
      class: "novice",
      text: "A beginning certificate associated with introductory courses. Completing this certificate will provide you with a solid foundation in your knowledge and skills as you get started in ClickUp.",
      url: "/path/clickup-for-beginners?reg=1",
    },
    {
      src: "https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-expert-badge.png",
      title: "Expert Certificate",
      class: "intermediate",
      text: "Geared towards building and applying your ClickUp skills and knowledge on core features that help you level up your productivity.",
      url: "/path/become-a-clickup-expert",
    },
    {
      src: "https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-admin-badge.png",
      title: "Admin Certificate",
      class: "expert",
      text: "Geared towards ClickUp admins of Workspaces who want to show the world they are experts in both ClickUp and productivity.",
      url: "/path/clickup-admin-certificate-prep",
    },
    {
      src: "https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-advanced-ai-skills-badge.png",
      title: "ClickUp Advanced AI Skills Certificate",
      class: "expert",
      text: "Become an AI champion with ClickUp Advanced AI Skills certification. Master ClickUp Brain and AI tools.",
      url: "/path/clickup-advanced-ai-skills",
    },
  ];

  for (let card of badgeCards) {
    let badgeCard = document.createElement("A");
    badgeCard.classList.add("badge-card");
    badgeCard.href = card.url;
    badgeCard.innerHTML = `
            <img src="${card.src}">
            <h3>${card.title}</h3>
            <p>${card.text}</p>
            <div class="btn-text ${card.class}">View Learning Path</div>
        `;

    badgeCardSection.append(badgeCard);
  }

  badgeSection.append(badgeCardSection);

  sjContent.prepend(badgeSection);
  sjContent.prepend(pageSubHeader);
  sjContent.prepend(pageHeader);
}
